<template>
  <div v-if="act != null" class="theme-mml" style="height: 100% !important">
    <div id="base_body_header_wrap">
      <div class="color-header">
        <div class="row">
          <div class="col-lg-offset-2 col-lg-8 col-sm-10" v-if="act != null" style="
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 50px;
              ">
            <h4 class="h1-test-container" style="padding-top: unset !important; font-size: 20px; text-align: center;">
              {{ act.documentInfo.dataActCloserDesignation }}
            </h4>
          </div>
        </div>
      </div>
      <div class="white-header">
        <div class="title-act-mml">
          <div class="row">
            <div class="col-lg-offset-2 col-xl-8 col-lg-10 col-sm-12" v-if="act != null">
              <div class="row hidden-xs col-wrap">
                <div class="col-lg-3 col-sm-3 act-mml-table-title">
                  <span>Врста</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-mml-table-title">
                  <span>Доносилац / Аутор</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-mml-table-title">
                  <span>Основни пропис</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-mml-table-title">
                  <span>Начин објаве</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-mml-table-content">
                  <span :title="act.documentInfo.typeRootName">{{
    act.documentInfo.typeRootName
  }}</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-mml-table-content">
                  <span :title="act.documentInfo.authorityName">{{
    act.documentInfo.authorityName
  }}</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-mml-table-content">
                  <span :title="act.documentInfo.dataPrincipalAct">{{
    act.documentInfo.dataPrincipalAct
  }}</span>
                </div>
                <div class="col-lg-3 col-sm-3 act-mml-table-content">
                  <span :title="act.documentInfo.defSourceName">{{
    act.documentInfo.defSourceName
  }}</span>
                </div>
              </div>
              <div class="row visible-xs">
                <div class="col-xs-12 act-mml-table-xs">
                  <span>Врста: </span>
                  <span>{{ act.documentInfo.typeRootName }}</span>
                </div>
                <div class="col-xs-12 act-mml-table-xs">
                  <span>Доносилац / Аутор:
                    <span>{{ act.documentInfo.authorityName }}</span></span>
                </div>
                <div class="col-xs-12 act-mml-table-xs">
                  <span>Основни пропис:
                    <span>{{ act.documentInfo.dataPrincipalAct }}</span></span>
                </div>
                <div class="col-xs-12 act-mml-table-xs">
                  <span>Начин објаве:
                    <span>{{ act.documentInfo.defSourceName }}</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div id="searchBarPrimary" :class="{
    'col-lg-offset-2 col-xl-8 col-md-offset-0 col-lg-10 col-sm-offset-0 col-xs-offset-0 col-sm-12 col-xs-12':
      contentSecondary === null && contentSecondaryLink === '',
    'col-lg-5 col-md-5 hidden-xs hidden-sm':
      contentSecondary !== null || contentSecondaryLink !== '',
  }">
          <div class="input-group">
            <span class="input-group-btn">
              <button v-if="act.documentInfo.dataHtmlUuid !== null && act.documentInfo.dataHtmlUuid !== ''"
                type="button" class="btn btn-default" @click="onPrintPrimaryClick()" title="Штампа">
                <span class="fa fa-print"></span>
              </button>
              <button v-if="act.documentInfo.dataHtmlUuid !== null && act.documentInfo.dataHtmlUuid !== ''"
                class="btn btn-default" type="button" @click="onOnlyActContentClick()" title="Отвори само текст акта">
                <span class="fa fa-external-link"></span>
              </button>
              <button v-else class="btn btn-default" type="button" title="Отвори само текст акта"
                @click="openPdfInNewTab('/mmlViewPdf/' + act.documentInfo.dataId)">
                <!-- <router-link style="color: #333;" :to="'/mmlViewPdf/' + act.documentInfo.dataId" replace target="_blank"> -->
                <span class="fa fa-external-link"></span>

                <!-- </router-link> -->
              </button>
              <button type="button" class="btn btn-default" @click="onPrimaryPreviousClick()" title="Претходни резултат">
                <span class="fa fa-chevron-left"></span>
              </button>
            </span>
            <input @keyup="primaryKeyUp" v-model="textSearchPrimary" type="text"
              class="form-control ng-pristine ng-untouched ng-valid" placeholder="Претрага по приказаном тексту" />
            <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="onPrimaryNextClick()" title="Следећи резултат">
                <span class="fa fa-chevron-right"></span>
              </button>
            </span>
          </div>
        </div>
        <div v-if="contentSecondaryLink !== '' || contentSecondary !== null" :class="{ 'col-lg-5 col-md-5': true }">
          <div class="input-group secondary-search">
            <span class="input-group-btn left-search">
              <button class="btn btn-default" type="button" @click="closeSecondary" title="Затвори панел">
                <span class="fa fa-times"></span>
              </button>
              <button class="btn btn-default" type="button" @click="onPrintSecondaryClick" title="Штампа">
                <span class="fa fa-print"></span>
              </button>
            </span>
            <span class="input-group-btn previous-solo-btn">
              <button class="btn btn-default" type="button" @click="onSecondaryPreviousClick"
                title="Претходни резултат">
                <span class="fa fa-chevron-left"></span>
              </button>
            </span>
            <input @keyup="secondaryKeyUp" v-model="textSearchSecondary" type="text" class="form-control"
              placeholder="Претрага по приказаном тексту" />
            <span class="input-group-btn right-search">
              <button class="last-btn btn btn-default" type="button" @click="onSecondaryNextClick"
                title="Следећи резултат">
                <span class="fa fa-chevron-right"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div :class="{
    'col-lg-offset-2 col-xl-8 col-lg-10 col-sm-12':
      contentSecondary === null && contentSecondaryLink === '',
    'col-lg-5 col-md-5 hidden-xs hidden-sm':
      contentSecondary !== null || contentSecondaryLink !== '',
  }" style="
            height: -moz-calc(100% - 148px);
            height: -webkit-calc(100% - 148px);
            height: -o-calc(100% - 148px);
            height: calc(100% - 148px);
          ">
        <div id="actContentPrimaryScroll" width="100%" height="100%" :class="{
    hideContainer:
      (
        contentPrimary !== null &&
        !contentPrimary
          .substr(0, contentPrimary.indexOf('</head>'))
          .includes('glasnik.css'))
  }" v-if="contentPrimary !== null" class="view-act" style="overflow-y: auto; height: 688px" type="text/html">
          <HtmlDiv v-if="contentPrimary
    .substr(0, contentPrimary.indexOf('</head>'))
    .includes('glasnik.css') && hasHtml
    " id="primaryContentHtml" v-html="contentPrimary" width="100%" height="800px">
          </HtmlDiv>
          <div style="height: calc(100vh - 300px) !important; overflow-y: auto" class="iframe-styles iframe-height"
            v-else-if="!contentPrimary
    .substr(0, contentPrimary.indexOf('</head>'))
    .includes('glasnik.css') && hasHtml
    " id="primaryContentHtml" v-html="contentPrimary" width="100%" height="800px">
          </div>
          <PDFJSViewer v-else style="height: calc(100vh - 300px) !important;" id="primaryContentHtml"
            :srcUrl="contentPrimary"></PDFJSViewer>
        </div>
      </div>
      <div v-if="contentSecondaryLink !== '' || contentSecondary !== null" :class="{ 'col-lg-5 col-md-5': true }"
        class="secondary-frame-parent" style="height: 100%;">
        <div class="table-panel1" style="height: calc(100% - 44px);">
          <div id="actContentSecondaryScroll" style="overflow:'scroll'" class="view-act-secondary card-1"
            v-if="contentSecondaryLink !== '' || contentSecondary !== null">
            <HtmlDiv id="actContentSecondary" v-html="contentSecondary" :showChanges="true" width="100%" height="100%"
              style="font-size: 0.80rem;"></HtmlDiv>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-lg-2-custom-class-width-12 col-sm-12 panel-group right-panel"
        v-if="act !== null && act.documentInfo !== null" style="
            padding-bottom: 40px;
            padding-left: 15px;
            height: 65vh !important;
          ">
        <div class="panel panel-default" id="panelPodvrstaModela" v-if="act.documentInfo.typeParentName !== null &&
    act.documentInfo.typeParentName !== '' &&
    act.documentInfo.typeRootId === '4'
    ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapsePodvrstaModela">
                Подврсте модела уговора и других аката
              </a>
            </h5>
          </div>
          <div id="collapsePodvrstaModela" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.typeParentName }}</p>
          </div>
        </div>
        <div class="panel panel-default" id="panelPodvrsta" v-if="act.documentInfo.typeName !== null &&
    act.documentInfo.typeName !== ''
    ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapsePodvrsta">
                {{
    act.documentInfo.typeRootId === "4"
      ? "Тип / Област"
      : "Подврста"
  }}
              </a>
            </h5>
          </div>
          <div id="collapsePodvrsta" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.typeName }}</p>
          </div>
        </div>
        <div v-if="act.documentInfo.dataActLabelNumberHtml !== null && act.documentInfo.dataActLabelNumberHtml !== ''">
          <div class="panel panel-default" id="panelOznakaBrojAkta">
            <div class="panel-heading">
              <h5 class="panel-title">
                <a class="panel-link" data-toggle="collapse" :data-target="collapseTarget">
                  Ознака / број акта
                </a>
              </h5>
            </div>
            <div :id="collapseId" class="panel-body panel-collapse collapse in show">
              <p>{{ act.documentInfo.dataActLabelNumberHtml }}</p>
            </div>
          </div>
        </div>
        <div class="panel panel-default" id="panelOsnovniPropis" v-if="act.documentInfo.dataPrincipalAct !== null &&
    act.documentInfo.dataPrincipalAct !== ''
    ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseOsnovniPropis">
                Основни пропис
              </a>
            </h5>
          </div>
          <div id="collapseOsnovniPropis" class="panel-body panel-collapse collapse in show" @click="handleArticleClick"
            v-html="act.documentInfo.dataPrincipalActHtml"></div>
        </div>
        <div class="panel panel-default" id="panelDrugiPropisi" v-if="act.documentInfo.dataOtherActs !== null &&
    act.documentInfo.dataOtherActs !== ''
    ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseDrugiPropisi">
                Други прописи
              </a>
            </h5>
          </div>
          <div id="collapseDrugiPropisi" class="panel-body panel-collapse collapse in show" @click="handleArticleClick"
            v-html="act.documentInfo.dataOtherActsHtml"></div>
        </div>
        <div class="panel panel-default" id="panelReferences"
          v-if="act.references !== null && act.references.length > 0">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a data-toggle="collapse" class="panel-link" data-target="#collapseReferences">Повезани акти</a>
            </h5>
          </div>
          <div id="collapseReferences" class="panel-body panel-collapse collapse in list-panel show">
            <ul class="panel-body list-group" style="padding: 0px !important">
              <li class="list-group-item" v-for="ref in act.references" :key="ref.url">
                <a rel="nofollow" :href="ref.url" target="_blank">{{
    ref.name
  }}</a>
              </li>
              <!-- end ngRepeat: ref in act.references -->
            </ul>
          </div>
        </div>
        <div class="panel panel-default" id="panelNaciniObjave" v-if="act.documentInfo.defSourceName !== null &&
    act.documentInfo.defSourceName !== ''
    ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseNaciniObjave">
                Сви начини објаве
              </a>
            </h5>
          </div>
          <div id="collapseNaciniObjave" class="panel-body panel-collapse collapse in show"
            v-html="act.documentInfo.sourceHtml"></div>
        </div>
        <div class="panel panel-default" id="panelDatum" v-if="act.documentInfo.dataEnactmentDate !== null &&
    act.documentInfo.dataShowEnactmentDate === true
    ">
          <div class="panel-heading">
            <h5 class="panel-title">
              <a class="panel-link" data-toggle="collapse" data-target="#collapseDatum">
                Датум
              </a>
            </h5>
          </div>
          <div id="collapseDatum" class="panel-body panel-collapse collapse in show">
            <p>{{ act.documentInfo.dataEnactmentDate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import axios from "axios";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery-highlight/jquery.highlight.js";
import { customAxios } from "@/utils/custom-axios";
import HtmlDiv from "@/components/HtmlDiv.vue";
import PDFJSViewer from "@/components/PDFJSViewer.vue";
//import { changeImageSrc } from "../../utils/helper-methods";

export default {
  name: "ViewActPage",
  data() {
    return {
      baseApiUrl: window.env.VUE_APP_API_MML_DEV,
      baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
      act: null,
      hasHtml: true,
      contentPrimary: null,
      contentSecondary: null,
      contentSecondaryLink: "",
      textSearchPrimary: "",
      textSearchSecondary: "",
      scrollIndexPrimary: 0,
      scrollIndexSecondary: 0,
    };
  },
  watch: {
    textSearchPrimary(newValue) {
      window
        .$("#actContentPrimaryScroll")
        .unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentPrimaryScroll")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndexPrimary = 0;
    },
    textSearchSecondary(newValue) {
      window
        .$("#actContentSecondaryScroll")
        .unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentSecondaryScroll")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndexSecondary = 0;
    },
    contentSecondaryLink() {
      if (this.contentSecondaryLink !== "") {
        axios.get(this.contentSecondaryLink).then((response) => {
          this.contentSecondary = response.data;
          this.$nextTick(() => {
            const styleTags = document.getElementById('actContentSecondary').querySelectorAll('style');
            styleTags.forEach(styleTag => {
              styleTag.innerHTML = '#actContentSecondary' + styleTag.innerHTML;
              styleTag.innerHTML = styleTag.innerHTML.replace(/}/g, '} #actContentSecondary');
            });
            window.$("#actContentSecondary").on("click auxclick", function (e) {
              if (
                e.target.nodeName === "A" ||
                e.target.parentElement.nodeName === "A"
              ) {
                if (e.target.nodeName === "A") {
                  if (e.target.href.includes("/viewdoc"))
                    e.target.href = e.target.href.substr(
                      e.target.href.indexOf("/viewdoc")
                    );
                }
              }
            });
          });
        });
      }
    },
  },
  methods: {
    closeSecondary() {
      this.contentSecondaryLink = "";
      this.textSearchSecondary = "";
      this.contentSecondary = null;
    },
    onPrintPrimaryClick() {
      if (this.act.documentInfo.dataHtmlUuid !== null && this.act.documentInfo.dataHtmlUuid !== "") {
        axios
          .get(this.baseApiUrl +
            "prins/viewdoc?uuid=" +
            this.act.documentInfo.dataHtmlUuid +
            "&actId=" +
            this.act.documentInfo.dataId.toString() +
            "&doctype=mml")
          .then((response) => {
            var tab = window.open('', '_blank');
            tab.document.write(response.data); // where 'html' is a variable containing your HTML
            tab.document.close();
            setTimeout(() => {
              tab.print();
              tab.close();
            }, 100);
          })
      }

    },
    onPrintSecondaryClick() {
      var printContents = window.$("#actContentSecondary").html();
      printContents = printContents.replace(/glasnik.css/, this.baseREGApiUrl + 'glasnik.css');
      var popupWin = window.open("", "_blank");
      popupWin.document.open();
      if (typeof printContents !== "undefined") {
        popupWin.document.write(
          '<html><head></head><body onload="window.print(); window.close();">' +
          printContents +
          "</body></html>"
        );
      }
      popupWin.document.close();
    },
    onOnlyActContentClick() {
      window.open(
        this.baseApiUrl +
        "prins/viewdoc?uuid=" +
        this.act.documentInfo.dataHtmlUuid +
        "&actId=" +
        this.act.documentInfo.dataId.toString() +
        "&doctype=mml",
        "_blank"
      );
    },
    primaryKeyUp(event) {
      if (event.keyCode === 13) {
        this.onPrimaryNextClick();
      }
    },
    secondaryKeyUp(event) {
      if (event.keyCode === 13) {
        this.onSecondaryNextClick();
      }
    },
    onPrimaryPreviousClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexPrimary--;
        if (this.scrollIndexPrimary < 0) {
          this.scrollIndexPrimary = items.length;
        }
        if (items.length > 0) {
          items[this.scrollIndexPrimary].scrollIntoView();
        }
      }
    },
    onSecondaryPreviousClick() {
      var items = window.$("#actContentSecondaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexSecondary--;
        if (this.scrollIndexSecondary < 0) {
          this.scrollIndexSecondary = items.length;
        }
        if (items.length > 0) {
          items[this.scrollIndexSecondary].scrollIntoView();
        }
      }
    },
    onPrimaryNextClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexPrimary++;
        if (this.scrollIndexPrimary > items.length) {
          this.scrollIndexPrimary = 0;
        }
        items[this.scrollIndexPrimary].scrollIntoView();
      }
    },
    onSecondaryNextClick() {
      var items = window.$("#actContentSecondaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexSecondary++;
        if (this.scrollIndexSecondary > items.length) {
          this.scrollIndexSecondary = 0;
        }
        items[this.scrollIndexSecondary].scrollIntoView();
      }
    },
    handleArticleClick(event) {
      const target = event.target;
      if (
        target.tagName === "A" &&
        target.classList.contains("linkZaRegistar")
      ) {
        const dataCustomValue = target.getAttribute("data-click");
        this.openInline(dataCustomValue);
      }
    },
    openInline(link) {
      this.contentSecondaryLink = link;
    },
    openPdfInNewTab(url) {
      const routeData = this.$router.resolve(url, this.$route);
      window.open(routeData.href, '_blank');
    }
  },
  async mounted() {
    //var self = this;
    await axios
      .get(this.baseApiUrl + "Prins/GetDataView/" + this.$route.params.actId)
      .then((response) => {
        this.act = response.data;
        this.hasHtml = this.act.documentInfo.dataHtmlUuid ? true : false;
        customAxios(this.hasHtml ? "" : "blob")
          .get(this.baseApiUrl + "Prins/viewAct/" + this.$route.params.actId)
          .then((response) => {
            if (!this.hasHtml) {
              const file = new Blob([response.data], {
                type: "application/pdf",
              });
              const fileurl = URL.createObjectURL(file);
              this.contentPrimary = fileurl;
            } else {
              this.contentPrimary = response.data;
              // const newContent = changeImageSrc(
              //   this.contentPrimary,
              //   this.baseApiUrl + "prins/",
              //   this.$route.params.actId
              // );
              // this.contentPrimary = newContent;
            }

            this.$nextTick(() => {
              const styleTags = document.getElementById('primaryContentHtml').querySelectorAll('style');
              styleTags.forEach(styleTag => {
                styleTag.innerHTML = '#primaryContentHtml' + styleTag.innerHTML;
                styleTag.innerHTML = styleTag.innerHTML.replace(/}/g, '} #primaryContentHtml').replace(/&gt;/g, '>');
              });
              const scriptTags = document.getElementById('primaryContentHtml').querySelectorAll('script')
              scriptTags.forEach(script => {
                script.innerHTML = script.innerHTML.replace(/^http:/, 'https:').replace(/&gt;/g, '>');
                eval(script.innerHTML);
              })
              window.$("#primaryContentHtml").on("click auxclick", function (e) {
                if (
                  e.target.nodeName === "A" ||
                  e.target.parentElement.nodeName === "A"
                ) {
                  if (e.target.nodeName === "A") {
                    if (e.target.href.includes("/viewdoc"))
                      e.target.href = e.target.href.substr(
                        e.target.href.indexOf("/viewdoc")
                      );
                  }
                }
              });
            });
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) window.location.href = '/'
      });

    window.addEventListener('keydown', function (event) {
      if ((event.ctrlKey && event.keyCode === 83) || (event.ctrlKey && event.keyCode === 80))
        event.preventDefault();
    })
  },
  beforeCreate: function () {
    document.body.className = "color_mml view-act-page";
  },
  components: { HtmlDiv, PDFJSViewer },
};
</script>

<style scoped>
@import "~@fortawesome/fontawesome-free/css/all.css";

#actContentPrimaryScroll {
  height: 658px;
}

#actContentSecondaryScroll {
  height: calc(100vh - 300px) !important;
  background-color: white !important;
  overflow: auto;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  position: relative;
}

.color-header {
  background: #8650a1;
  background: -webkit-linear-gradient(top, #9b5dba 0%, #8650a1 100%);
  background: -moz-linear-gradient(top, #9b5dba 0%, #8650a1 100%);
  background: -ms-linear-gradient(top, #9b5dba 0%, #8650a1 100%);
  background: -o-linear-gradient(top, #9b5dba 0%, #8650a1 100%);
  background: linear-gradient(to bottom, #9b5dba 0%, #8650a1 100%);
  background-color: rgba(0, 0, 0, 0);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#9b5dba', endColorstr='#8650a1', GradientType=0);
  color: #ffffff !important;
  border: 0;
}

@media (min-width: 1200px) {
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
}

.theme-mml .act-mml-table-title {
  height: 25px;
  background: #dbd7d2;
  color: #036104;
  line-height: 25px;
  border-left: 1px solid #a49e94;
  border-right: 1px solid #a49e94;
  font-weight: 600;
}

.theme-mml .act-mml-table-content {
  height: 30px;
  border-bottom: 1px solid #a49e94;
}

.theme-mml .act-mml-table-content {
  height: 25px;
  background: #ffffff;
  color: #036104;
  border-left: 1px solid #a49e94;
  border-right: 1px solid #a49e94;
  font-weight: 500;
  overflow: hidden;
}

.visible-xs {
  display: none !important;
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }

  .visible-xs {
    display: block !important;
  }
}

.theme-mml .right-panel {
  margin-bottom: 0px !important;
}

.col-lg-2-custom-class-width-12 {
  padding-bottom: 40px !important;
  padding-left: 5px !important;
  overflow-y: auto !important;
  height: 65vh !important;
  width: 13% !important;
  max-width: 13% !important;
  padding-right: 0px !important;
}

.panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
}

.panel-default {
  border-color: #ddd;
  border: 1px solid #ddd !important;
  margin-bottom: 5px !important;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.theme-mml .panel-heading {
  background: #eaeaea;
  cursor: pointer;
  color: #333333 !important;

  :hover {
    text-decoration: underline;
  }
}

.theme-mml .panel-title {
  font-size: 88%;
  /*(14px) */
  margin-bottom: 0;
}

.theme-mml .panel-title .panel-link {
  color: #000 !important;
  font-weight: 400;
}

.panel-body.panel-collapse p,
#collapseDrugiPropisi,
#collapseOsnovniPropis,
#collapseNaciniObjave,
#collapseReferences {
  font-size: 70%;
  /* font-size: 11px;  */
}

.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.input-group-btn:first-child>.btn,
.input-group-btn:first-child>.btn-group {
  margin-right: -1px;
}

.input-group-btn>.btn {
  position: relative;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 88%;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc !important;
}

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child>.btn,
.input-group-btn:first-child>.btn-group>.btn,
.input-group-btn:first-child>.dropdown-toggle,
.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,
.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,
.input-group-btn:first-child>.btn:not(:first-child),
.input-group-btn:last-child>.btn,
.input-group-btn:last-child>.btn-group>.btn,
.input-group-btn:last-child>.dropdown-toggle {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-left: none;
}

.input-group-btn {
  display: flex;
  box-shadow: none !important
}

.base-body-wrap #actContentPrimaryScroll {
  border: none;
  overflow-y: hidden !important;
}

#actContentPrimaryScroll {
  height: calc(100vh - 300px) !important;
}

.view-act {
  margin-top: 5px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  height: 100%;
  min-height: 200px;
}

.theme-mml .title-act-mml {
  color: #ffffff;
  text-align: center;
  border-bottom: 3px solid rgb(248, 248, 248);
  padding-left: 23px;
  padding-right: 23px;
}

.theme-mml .title-act-mml {
  min-height: auto;
}

.theme-mml .act-mml-table-content {
  height: 30px;
  border-bottom: 1px solid #a49e94;
  line-height: 1.4;
}

.theme-mml .linkZaRegistar,
.theme-mml .linkZaArhivu,
.theme-mml .act-mml-table-content,
.theme-mml .act-mml-table-title {
  color: #8650a1;
}

.btn-default:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}

.theme-mml .panel-body {
  padding: 0 5px;
  margin: 5px 0;
}

.panel-body.list-group .list-group-item {
  margin: 0 !important;
  border: none !important;
  padding: 0 !important;
}

.panel-body.list-group .list-group-item a {
  color: #8650a1 !important;
}

.act-mml-table-title,
.act-mml-table-title span {
  font-size: 83% !important;
  /*(11px) */
}

.panel-group p {
  margin-bottom: 0 !important;
}

#panelPodvrsta p {
  font-family: inherit;
}

#primaryContentHtml {
  padding: 5px;
}

iframe {
  height: 800px !important;
}

iframe-height {
  height: 800px !important;
}

@media (max-width: 1200px) {
  .col-lg-2-custom-class-width-12 {
    width: 100% !important;
    padding: 20px !important;
    max-width: 100% !important;
  }
}

#searchBarPrimary input.form-control::placeholder,
.secondary-search input.form-control::placeholder {
  color: #a69999 !important;
  font-size: 100% !important;
}

.secondary-search .btn-default:hover,
#searchBarPrimary .btn-default:hover {
  color: #333;
  background-color: #e6e6e6 !important;
  border-color: #adadad !important;
}

#searchBarPrimary input.form-control,
.secondary-search input.form-control {
  font-size: 88% !important;
  /*(14px) */
  height: 38px;
}

#collapseReferences .list-group-item {
  padding-bottom: 5px !important;
  border-bottom: 1px solid #ddd !important;
  margin-bottom: 5px !important;
}

#collapseReferences .list-group-item:last-child {
  padding-bottom: 0 !important;
  border-bottom: none !important;
  margin-bottom: 0px !important;
}

@media (max-width: 1199px) {
  .title-act-mml {
    padding: 0 !important;
  }

  .title-act-mml .row {
    margin: 0 !important;
  }

  .title-act-mml .col-lg-offset-2.col-xl-8.col-lg-10.col-sm-12 {
    padding: 0 !important;
    padding-right: 5px !important;
  }
}

@media (max-width: 991px) {

  .title-act-mml .col-lg-offset-2.col-xl-8.col-lg-10.col-sm-12 {
    padding-right: 0px !important;
  }
}

.title-act-mml {
  border-color: #fff !important;
}
</style>
